import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import AzureInputs from './components/AzureInputs/AzureInputs.container'
import AmazonS3Inputs from './components/AmazonS3Inputs/AmazonS3Inputs.container'
import GoogleStorageInputs from './components/GoogleStorageInputs/GoogleStorageInputs.container'
import OBSS3Inputs from './components/OBSS3/OBSS3Inputs.container'
// import TokenSelector from './components/TokenSelector/TokenSelector.container'

import Select from 'shared/components/form/Select/Select.component'
import Spinner from 'shared/components/common/Spinner/Spinner.component'

import { createDivAtom } from 'shared/atoms/factory'

import styles from './ExportApiConfig.module.scss'

const Wrapper = createDivAtom(),
      ContentWrapper = createDivAtom(),
      FormWrapper = createDivAtom(),
      Title = createDivAtom(),
      StorageTypeNotSelected = createDivAtom()

const storageTypes = [
  { name: 'Select the storage type', code: '' },
  { name: 'Amazon S3', code: 'amazonS3' },
  { name: 'Google Storage', code: 'googleStorage' },
  { name: 'Microsoft Azure Blob', code: 'azureBlob' },
  { name: 'OBS S3', code: 'obsS3' }
]

const ReportingConfig = props => {
  const {
    agentId,
    storageType,
    isFetching,
    isSaving,
    updateExportApiConfig,
    fetchExportApiConfig
  } = props

  useEffect(() => {
    if(agentId && agentId !== 'default') {
      fetchExportApiConfig()
    }
  }, [ agentId ])

  const renderStorageInputs = () => {
    switch (storageType) {
      case 'azureBlob': {
        return <AzureInputs />
      }

      case 'amazonS3': {
        return <AmazonS3Inputs />
      }

      case 'googleStorage': {
        return <GoogleStorageInputs />
      }

      case 'obsS3': {
        return <OBSS3Inputs />
      }

      default: {
        return <StorageTypeNotSelected className={styles.storageTypeNotSelected}>

        </StorageTypeNotSelected>
      }
    }
  }

  return (
    <Wrapper className={styles.wrapper}>
      <Spinner visible={isFetching || isSaving} />

      <ContentWrapper className={styles.contentWrapper}>
        <Title className={styles.title}>
          Analytics API config
        </Title>

        <FormWrapper
          className={styles.formWrapper}
        >
          {/* <TokenSelector /> */}
          <Select
            className={styles.select}
            title={'Storage location'}
            onChange={updateExportApiConfig('storageType')}
            data={storageTypes}
            value={storageType}
            disabled={isFetching || isSaving}
          />

          {renderStorageInputs()}
        </FormWrapper>
      </ContentWrapper>
    </Wrapper>
  )
}

ReportingConfig.propTypes = {
  agentId: PropTypes.string,
  storageType: PropTypes.string,
  isFetching: PropTypes.bool,
  isSaving: PropTypes.bool,
  updateExportApiConfig: PropTypes.func,
  fetchExportApiConfig: PropTypes.func
}

export default ReportingConfig
